import { connect, ConnectedProps } from "react-redux";
import { setFlightInfo } from "../../actions/actions";
import { IStoreState } from "../../../../reducers/types";
import { FlightNumberForm } from "./component";
import { getFlightInfo, getFlightInfoFieldSpec } from "../../reducer";

const mapStateToProps = (state: IStoreState) => ({
  flightInfo: getFlightInfo(state),
  flightInfoFieldSpec: getFlightInfoFieldSpec(state),
});

const mapDispatchToProps = {
  setFlightInfo,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type FlightNumberFormConnectorProps = ConnectedProps<typeof connector>;

export const ConnectedFlightNumberForm = connector(FlightNumberForm);
